module.exports = __webpack_public_path__ + "img/ceo.8a44d964.png";